import React, { useState } from 'react';
import {
  Box,
  Typography,
  Popover,
  Button,
  CircularProgress,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';

import { useVersion } from '../hooks/useVersion';
import styles from './OTMVersionInfo.styles';

export default function OTMVersionInfo() {
  const [anchorPos, setAnchorPos] = useState(null);
  const { loading, data, notFound, error } = useVersion();

  const handleOpen = (e) => setAnchorPos({ top: e.clientY, left: e.clientX });
  const handleClose = () => setAnchorPos(null);
  const open = Boolean(anchorPos);

  const releaseLabel = data?.otmRelease ?? 'Version';

  const formattedDate = data?.releaseDate
    ? new Date(data.releaseDate).toLocaleDateString('en-GB')
    : '—';

  return (
    <>
      <Button
        data-testid="version-trigger"
        onClick={handleOpen}
        sx={styles.versionButton}
        aria-label="OTM release version"
        type="button"
      >
        {loading ? (
          <CircularProgress size={13} sx={{ color: '#5236AB' }} />
        ) : (
          releaseLabel
        )}
      </Button>

      <Popover
        open={open}
        anchorReference="anchorPosition"
        anchorPosition={anchorPos}
        onClose={handleClose}
      >
        <Box sx={styles.popoverContent}>
          {loading && (
            <Box sx={styles.center}>
              <CircularProgress size={24} sx={{ color: '#5236AB' }} />
            </Box>
          )}

          {!loading && notFound && (
            <Typography sx={styles.message}>
              No OTM release version found
            </Typography>
          )}

          {!loading && error && (
            <Typography sx={styles.errorMessage}>{error}</Typography>
          )}

          {!loading && data && (
            <>
              <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', mb: 1.5 }}>
                <Typography sx={styles.releaseTitle}>{data.otmRelease}</Typography>
                <Typography sx={styles.releaseDate}>{formattedDate}</Typography>
              </Box>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={styles.headerCell}>Component</TableCell>
                    <TableCell sx={styles.headerCell}>Version</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(data.components || []).map((c) => (
                    <TableRow key={c.name}>
                      <TableCell>
                        <Typography variant="body2">{c.name ?? '—'}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">{c.version ?? '—'}</Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </>
          )}
        </Box>
      </Popover>
    </>
  );
}
